import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(saveAbDataToLocalStorageSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(clearAbDataFromLocalStorageSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(abSagas);

import { select, takeEvery, takeLatest } from 'redux-saga/effects';
import { abSelectors, SET_AB_DATA, CLEAR_AB_DATA } from './ab-reducer';

var AB_DATA_LOCAL_STORAGE_KEY = 'abData';

function saveAbDataToLocalStorageSaga() {
  var abData;
  return _regeneratorRuntime.wrap(function saveAbDataToLocalStorageSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(abSelectors.getAbData);

        case 2:
          abData = _context.sent;

          localStorage.setItem(AB_DATA_LOCAL_STORAGE_KEY, abData);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

// eslint-disable-next-line
function clearAbDataFromLocalStorageSaga() {
  return _regeneratorRuntime.wrap(function clearAbDataFromLocalStorageSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          localStorage.removeItem(AB_DATA_LOCAL_STORAGE_KEY);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export function abSagas() {
  return _regeneratorRuntime.wrap(function abSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeLatest(SET_AB_DATA, saveAbDataToLocalStorageSaga);

        case 2:
          _context3.next = 4;
          return takeEvery(CLEAR_AB_DATA, clearAbDataFromLocalStorageSaga);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}